import { get_route_language } from './routeLanguage';

export const init = (user, setTheme, setLanguage) => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    const savedLanguage = get_route_language(localStorage.getItem('language') || 'en');

    setTheme(savedTheme);
    setLanguage(savedLanguage);

    if (user?.preferences?.theme) {
        setTheme(user.preferences.theme);
    }

    if (user?.preferences?.language) {
        setLanguage(get_route_language(user.preferences.language));
    }
};

export const update_options_cookie = (userId) => {
    const theme = localStorage.getItem('theme') || 'light';
    const language = get_route_language(localStorage.getItem('language') || 'en');

    localStorage.setItem('theme', theme);
    localStorage.setItem('language', language);
    localStorage.setItem('menu_user_id', userId || '');
};
